import { newRxError as r } from "rxdb/plugins/core";
import { RXDB_VERSION as i } from "rxdb/plugins/utils";
import { RXDB_PREMIUM_VERSION as e } from "./rxdb-premium-version.js";
var o = !0;
export function disableVersionCheck() {
  o = !1;
}
export function checkVersion() {
  if (o && i !== e) throw r("SNH", {
    name: "Version mismatch detected",
    args: {
      rxdbVersion: i,
      rxdbPremiumVersion: e
    }
  });
}